import {Avatar} from 'antd'
import {getId, getType} from 'apis/model/base'
import classNames from 'classnames'
import EmptyHolder from 'components/EmptyHolder'
import {FollowButton} from 'components/Feed/FollowButton'
import {LayoutContext} from 'components/layouts/Default/LayoutContext'
import getAvatar from 'helpers/getAvatar'
import getLinkToDetail from 'helpers/getLinkToDetail'
import getTitle from 'helpers/getTitle'
import _ from 'lodash'
import {useAppConfig} from 'modules/local/AppConfigContext'
import useTranslate from 'modules/local/useTranslate'
import React, {useContext} from 'react'
import {BiSolidChurch} from 'react-icons/bi'
import {
    BsCameraVideo,
    BsFileEarmarkMusic,
    BsFileEarmarkSlides,
    BsInfoCircle,
    BsMusicNoteBeamed,
    BsPeopleFill,
    BsPersonFill
} from 'react-icons/bs'
import {HiOutlineMusicNote} from 'react-icons/hi'
import {IoHelp, IoNewspaper} from 'react-icons/io5'
import {RiCalendarEventLine, RiSignalTowerFill} from 'react-icons/ri'
import {Link} from 'react-router-dom'
import {AppEntities} from 'views/AppLocals/enums'
import {renderElse, renderIf} from 'views/Shared'
import {AskItemDiscovery} from '../../MainPage/functions/renderFeedAskItem'
import {ItemTemplate} from './renderSearchResultItem'
import TooltipApp from "components/TooltipApp";
import {ItemInformation} from 'components/common/ItemInformation'
import {formatDate} from "../../../helpers/datetimeHelpers";
import {formatSimplifyDate} from "../../../helpers/dateUtils";
import Translate from "../../../modules/local/Translate";
import ImageLoader from "../../../components/ImageLoader";
import {Photo} from "../../../conts/imageBase64";
import {ifThenElseMultipleConditions} from "../../../helpers/ifThenElseMultipleConditions";
import {OrgType} from "../../AppLocals/Organization/components/OrgType";

const MUSIC_RESOURCE_BADGE_CONFIG = {
    pdf: {icon: <BsFileEarmarkMusic size={10}/>, color: 'text-red-500', bg: 'bg-red-100', border: 'border-red-300', label: 'sheet music'},
    sheet: {icon: <HiOutlineMusicNote size={10}/>, color: 'text-green-600', bg: 'bg-green-50', border: 'border-green-300', label: 'sheet music'},
    audio: {icon: <BsMusicNoteBeamed size={10}/>, color: 'text-emerald-600', bg: 'bg-emerald-50', border: 'border-emerald-300', label: 'audio music'},
    video: {icon: <BsCameraVideo size={10}/>, color: 'text-pink-500', bg: 'bg-pink-50', border: 'border-pink-300', label: 'video'},
    slide: {icon: <BsFileEarmarkSlides size={10}/>, color: 'text-orange-500', bg: 'bg-orange-50', border: 'border-orange-300', label: 'slide'},
}

export const ResultCompactItem = ({item}) => {
    const t = useTranslate()

    const {isSm} = useContext(LayoutContext)

    const type = getType(item)

    const expired = _.get(item, 'is_expired')

    const {org_types = {}} = useAppConfig('org_types')

    const org_type = _.get(org_types, _.get(item, 'org_type', '900'))

    let label = ''
    let _className = 'background-200'
    let description = null
    let moreInfo
    let extra = null
    let icon
    let showBanner
    let target = item

    let renderLink = (item) =>
        renderElse(
            _.isEmpty(item),
            <Link to={getLinkToDetail(item)}
                  className="font-bold text-sm md:text-lg text-color-000 no-underline leading-snug">
                {getTitle(item)}
            </Link>
        )

    const ItemTooltip = ({label, value}) => (
        <div className="flex-1 items-baseline gap-1">
      <span className="text-xs text-color-400 font-light">
        {t(label)} {': '}
      </span>
            <span className="text-xs text-color-100 font-medium">{value}</span>
        </div>
    )

    switch (type) {
        case AppEntities.ORGANIZATION:
            _className = 'bg-primary-50'
            icon = <BiSolidChurch className="text-primary-400"/>
            label = ''
            description = t(org_type)
            moreInfo = (
                <div className="flex flex-col gap-1 mt-1">
                    {(_.get(item, 'phone') || _.get(item, 'address')) && (
                        <div className="flex flex-col gap-0.5">
                            {_.get(item, 'phone') && (
                                <ItemInformation
                                    showIcon={true}
                                    label="phone"
                                    value={item.phone}
                                    className="text-xs italic"
                                />
                            )}
                            {_.get(item, 'address') && (
                                <ItemInformation
                                    showIcon={true}
                                    label="address"
                                    value={item.address}
                                    className="text-xs italic max-lines-1"
                                />
                            )}
                        </div>
                    )}
                    {_.get(item, 'total_followers') > 0 && (
                        <span className="flex items-baseline gap-1 text-xs text-color-300 tracking-wider lowercase whitespace-nowrap">
                            <strong className="text-sm text-blue-500 tabular-nums">{Number(item.total_followers).toLocaleString()}</strong>
                            {t('followers')}
                        </span>
                    )}
                </div>
            )
            extra = (
                <div className="flex justify-end">
                    <FollowButton
                        item={item}
                        size="small"
                    />
                </div>
            )
            break
        case AppEntities.ASK:
            break
        case AppEntities.KEYWORD:
            break
        case AppEntities.DOCUMENT:
            break
        case AppEntities.CHANNEL:
            icon = <RiSignalTowerFill className="text-color-400"/>
            label = 'managed by'
            description = getTitle(_.get(item, 'owner'))
            moreInfo = (
                <div className="flex flex-col gap-1 mt-1">
                    <div className="flex items-center gap-3 flex-wrap">
                        {_.get(item, 'total_members') > 0 && (
                            <span className="flex items-baseline gap-1 text-xs text-color-300 tracking-wider lowercase whitespace-nowrap">
                                <strong className="text-sm text-blue-500 tabular-nums">{Number(item.total_members).toLocaleString()}</strong>
                                {t('members')}
                            </span>
                        )}
                        {_.get(item, 'total_followers') > 0 && (
                            <span className="flex items-baseline gap-1 text-xs text-color-300 tracking-wider lowercase whitespace-nowrap">
                                <strong className="text-sm text-blue-500 tabular-nums">{Number(item.total_followers).toLocaleString()}</strong>
                                {t('followers')}
                            </span>
                        )}
                        {_.get(item, 'total_articles') > 0 && (
                            <span className="flex items-baseline gap-1 text-xs text-color-300 tracking-wider lowercase whitespace-nowrap">
                                <strong className="text-sm text-blue-500 tabular-nums">{Number(item.total_articles).toLocaleString()}</strong>
                                {t('articles')}
                            </span>
                        )}
                    </div>
                    {item?.last_posted_at && (
                        <span className="text-2xs text-color-400 italic">
                            {`${t('last updated')} : `}{item.last_posted_at}
                        </span>
                    )}
                </div>
            )
            extra = (
                <div className="flex justify-end">
                    <FollowButton
                        item={item}
                        size="small"
                    />
                </div>
            )
            break
        case AppEntities.EVENT:
            label = 'organized by'
            description = _.get(item, 'owner.title')
            moreInfo = (
                <div className="flex flex-col gap-1 mt-1">
                    <div className="flex items-center gap-x-6">
                        <ItemInformation
                            showIcon={true}
                            label="type of event"
                            value={t(_.get(item, 'event_type'))}
                            className="text-xs italic"
                        />
                        <ItemInformation
                            showIcon={true}
                            label="start"
                            value={formatSimplifyDate(_.get(item, 'time_open'), 'fullTime')}
                            className="text-xs italic"
                        />
                    </div>
                    <div className="text-color-300 tracking-wider max-lines-2">
                        {_.get(item, 'description')}
                    </div>
                </div>
            )
            icon = <RiCalendarEventLine size={20} className="text-color-500"/>
            showBanner = false
            extra = (
                <div className="flex items-center justify-end gap-2">
          <span
              className={classNames('text-xs italic font-medium leading-tight mr-2', expired === true ? 'text-red-600' : 'text-blue-600')}>
            {expired === true ? t('closed') : t('opening')}
          </span>
                    <FollowButton
                        item={item}
                        size="small"
                    />
                </div>
            )
            break
        case AppEntities.COURSE:
            label = 'organized by'
            description = _.get(item, 'owner.title')
            icon = <IoHelp size={13}/>
            showBanner = false
            extra = (
                <div className="flex justify-end">
            <span
                className={classNames('text-xs italic font-medium', expired === true ? 'text-red-600' : 'text-primary')}>
              {expired === true ? t('closed') : t('opening')}
            </span>
                </div>
            )
            break
        case AppEntities.EXAMINATION:
            label = 'organized by'
            description = _.get(item, 'owner.title')
            icon = <IoHelp size={13}/>
            showBanner = false
            extra = (
                <div className="flex justify-end">
            <span
                className={classNames('text-xs italic font-medium', expired === true ? 'text-red-600' : 'text-primary')}>
              {expired === true ? t('closed') : t('opening')}
            </span>
                </div>
            )
            break
        case AppEntities.EXAMINATION_PAPER:
            renderLink = (item) =>
                renderElse(
                    _.isEmpty(item),
                    <Link
                        to={`/examination-paper/${getId(item)}`}
                        className="font-semibold text-color-000 max-lines-2">
                        {_.get(item, 'examinee_name')}
                    </Link>
                )
            label = 'ranking'
            description = t(_.get(item, 'score_ranking'))
            icon = <IoHelp size={13}/>
            extra = (
                <div className="flex justify-end">
                    <TooltipApp
                        color={'#fff'}
                        title={
                            <div>
                                <ItemTooltip
                                    label="date of birth"
                                    value={formatDate(_.get(item, 'date_of_birth'),
                                        'DD/MM/YYYY'
                                    )}
                                />
                                <ItemTooltip
                                    label="phone"
                                    value={_.get(item, 'phone_number')}
                                />
                                <ItemTooltip
                                    label="email"
                                    value={_.get(item, 'email')}
                                />
                            </div>
                        }
                        placement="left">
                        <BsInfoCircle className="text-color-200 cursor-pointer ml-2"/>
                    </TooltipApp>
                </div>
            )
            showBanner = false
            break
        case AppEntities.ARTICLE:
            icon = <IoNewspaper className="text-color-400"/>
            label = 'by'
            description = _.get(item, 'creator.name')
            break
        case AppEntities.PRODUCT:
            label = 'owner'
            description = getTitle(item?.owner)
            break
        case AppEntities.MUSIC:
            icon = <BsMusicNoteBeamed className="text-primary-400"/>
            label = 'author'
            description = (_.get(item, 'music_authors', []) || []).map((e) => e.fullname).join(', ')
            moreInfo = (
                <div className="flex flex-col gap-1.5 mt-1">
                    {_.get(item, 'music_types', []).length > 0 && (
                        <div className="flex flex-wrap gap-x-3 gap-y-1">
                            {item.music_types.map((mt, i) => (
                                <span key={i} className="text-xs italic font-medium text-primary">
                                    {mt.title}
                                </span>
                            ))}
                        </div>
                    )}
                    {_.get(item, 'resources', []).length > 0 && (
                        <div className="flex items-center gap-1 flex-wrap">
                            {_.uniq(item.resources.map((r) => r.data_type)).map((dataType) => {
                                const cfg = MUSIC_RESOURCE_BADGE_CONFIG[dataType]
                                if (!cfg) return null
                                return (
                                    <span
                                        key={dataType}
                                        className={classNames('px-1.5 py-0.5 flex items-center gap-1 rounded-md text-2xs font-semibold border', cfg.color, cfg.bg, cfg.border)}>
                                        {cfg.icon} {t(cfg.label)}
                                    </span>
                                )
                            })}
                        </div>
                    )}
                    <div className="flex items-center gap-3 flex-wrap">
                        {_.get(item, 'total_followers') > 0 && (
                            <span className="flex items-baseline gap-1 text-xs text-color-300 tracking-wider lowercase whitespace-nowrap">
                                <strong className="text-sm text-blue-500 tabular-nums">{Number(item.total_followers).toLocaleString()}</strong>
                                {t('followers')}
                            </span>
                        )}
                        {_.get(item, 'total_votes') > 0 && (
                            <span className="flex items-baseline gap-1 text-xs text-color-300 tracking-wider lowercase whitespace-nowrap">
                                <strong className="text-sm text-blue-500 tabular-nums">{Number(item.total_votes).toLocaleString()}</strong>
                                {t('votes')}
                            </span>
                        )}
                    </div>
                </div>
            )
            extra = (
                <div className="flex justify-end">
                    <FollowButton
                        item={item}
                        size="small"
                    />
                </div>
            )
            break
        case AppEntities.GROUP:
            icon = <BsPeopleFill className="text-primary-400"/>
            label = 'belongs to'
            description = getTitle(_.get(item, 'owner')) || _.get(item, 'group_title')
            moreInfo = (
                <div className="flex flex-col gap-1 mt-1">
                    <div className="flex items-center gap-3 flex-wrap">
                        {_.get(item, 'group_type') && (
                            <span
                                className="w-fit text-2xs font-medium bg-primary-50 text-primary italic"
                                style={{padding: '2px 8px', borderRadius: '0 10px 10px 9px'}}>
                                {t(item.group_type)}
                            </span>
                        )}
                        {_.get(item, 'member_count') > 0 && (
                            <span className="flex items-baseline gap-1 text-xs text-color-300 tracking-wider lowercase whitespace-nowrap">
                                <strong className="text-sm text-blue-500 tabular-nums">{Number(item.member_count).toLocaleString()}</strong>
                                {t('members')}
                            </span>
                        )}
                        {_.get(item, 'total_followers') > 0 && (
                            <span className="flex items-baseline gap-1 text-xs text-color-300 tracking-wider lowercase whitespace-nowrap">
                                <strong className="text-sm text-blue-500 tabular-nums">{Number(item.total_followers).toLocaleString()}</strong>
                                {t('followers')}
                            </span>
                        )}
                    </div>
                </div>
            )
            extra = (
                <div className="flex justify-end">
                    <FollowButton
                        item={item}
                        size="small"
                    />
                </div>
            )
            break
        case AppEntities.USER:
            icon = <BsPersonFill className="text-color-400"/>
            description = _.get(item, 'username') ? '@' + _.get(item, 'username') : null
            extra = (
                <div className="flex justify-end">
                    <FollowButton
                        item={item}
                        size="small"
                    />
                </div>
            )
            break
        default:
            break
    }
    return (
        <ItemTemplate item={item} showBanner={showBanner}>
            <div className="flex flex-col gap-1">
                <div className="flex items-center gap-3">
                    <Avatar
                        size={40}
                        shape={getType(item?.owner || item) === 'organization' ? 'square' : 'circle'}
                        className={classNames('flex flex-center 111-111', _className, getType(item?.owner || item) === 'organization' && 'rounded-md')}
                        icon={icon}
                        src={item?.avatar || getAvatar(item?.owner)}
                    />
                    <div className="flex flex-col flex-1">
                        {renderLink(target)}
                        {renderIf(
                            description,
                            <div className="flex items-center gap-1 italic leading-tight">
                                {renderIf(
                                    label,
                                    <span className="text-xs text-color-500">
                        {t(label)}
                      </span>
                                )}
                                <span className="font-medium text-xs text-blue-500 max-lines-1">
                    {description}
                  </span>
                            </div>
                        )}
                    </div>
                </div>
                {renderIf(
                    _.some([moreInfo, extra]),
                    <div className="w-full flex flex-col gap-2">
                        {moreInfo}
                        {extra}
                    </div>
                )}
            </div>
        </ItemTemplate>
    )
}

const createSearchResultComponent = (item, index) => {
    if (!!!getId(item)) return null

    const type = getType(item)

    let Component = () => <EmptyHolder/>

    switch (type) {
        case AppEntities.ASK:
            Component = AskItemDiscovery
            break
        case AppEntities.USER:
        case AppEntities.ORGANIZATION:
            return (
                <Translate>
                    {(t) => (
                        <div className="mb-6 p-3 flex flex-col gap-2 background shadow hover:shadow-md hover:scale-3xs rounded-xl relative">
                            <div className="flex items-center gap-3">
                                <Avatar
                                    size={36}
                                    src={getAvatar(item)}
                                    icon={<BiSolidChurch size={20} className="text-primary-400" />}
                                    className="flex flex-center bg-primary-50 rounded-md"
                                />
                                <div className="flex flex-col flex-1">
                                    <Link
                                        to={getLinkToDetail(item)}
                                        className="font-bold text-sm md:text-base text-color-000 no-underline leading-snug">
                                        {getTitle(item)}
                                    </Link>
                                    <OrgType item={item} className="font-medium text-xs text-blue-500 italic tracking-wide"/>
                                </div>
                            </div>
                            {renderIf(
                                _.get(item, 'description'),
                                <div className="ml-3 text-sm text-color-300 tracking-wider max-lines-2">
                                    {_.get(item, 'description')}
                                </div>
                            )}
                        </div>
                    )}
                </Translate>
            )
        case AppEntities.KEYWORD:
        case AppEntities.DOCUMENT:
        case AppEntities.CHANNEL:
            return (
                <Translate>
                    {(t) => (
                        <div className="mb-6 p-3 flex flex-col gap-2 background shadow hover:shadow-md hover:scale-3xs rounded-xl relative">
                            <div className="flex items-center gap-3">
                                <Avatar
                                    size={36}
                                    src={getAvatar(_.get(item, 'owner'))}
                                    icon={ifThenElseMultipleConditions(
                                        <RiSignalTowerFill size={20} className="text-color-500"/>,
                                        getType(_.get(item, 'owner')) === 'organization', <BiSolidChurch size={20} className="text-primary-400" />,
                                        getType(_.get(item, 'owner')) === 'user', <BsPersonFill size={20} className="text-color-500" />,
                                    )}
                                    className={classNames(
                                        "flex flex-center",
                                        getType(_.get(item, 'owner')) === 'organization' ?
                                            'bg-primary-50 rounded-md' : 'background-200 rounded-full'
                                    )}
                                />
                                <div className="flex flex-col flex-1">
                                    <Link
                                        to={getLinkToDetail(item)}
                                        className="font-bold text-sm md:text-lg text-color-000 no-underline leading-snug">
                                        {getTitle(item)}
                                    </Link>
                                    <div className="space-x-1 text-xs italic">
                                        <span className="text-color-500">
                                            {t('managed by')}
                                        </span>
                                        <span className="font-medium text-xs text-blue-500 italic">
                                            {getTitle(_.get(item, 'owner'))}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className="ml-3 text-sm text-color-300 tracking-wider max-lines-2">
                                {_.get(item, 'description')}
                            </div>
                            <div className="ml-3 flex flex-col gap-1 mt-1">
                                <div className="flex flex-col md:flex-row items-start md:items-center gap-x-6 gap-y-1">
                                    {renderIf(
                                        item?.total_articles,
                                        <div className="flex items-baseline text-sm gap-1 leading-tight">
                                            <span className="font-medium text-color-000">
                                                {item?.total_articles}
                                            </span>
                                            <span className="text-xs italic text-color-300">
                                                {t('articles')}
                                            </span>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    )}
                </Translate>
            )
        case AppEntities.EVENT:
            return (
                <Translate>
                    {(t) => (
                        <div className="mb-6 p-3 flex flex-col gap-2 background shadow hover:shadow-md rounded-xl relative">
                            <div className="flex items-center gap-3">
                                <Avatar
                                    size={36}
                                    src={getAvatar(_.get(item, 'owner'))}
                                    icon={ifThenElseMultipleConditions(
                                        <RiSignalTowerFill size={20} className="text-color-500"/>,
                                        getType(_.get(item, 'owner')) === 'organization', <BiSolidChurch size={20} className="text-primary-400" />,
                                        getType(_.get(item, 'owner')) === 'user', <BsPersonFill size={20} className="text-color-500" />,
                                    )}
                                    className={classNames(
                                        "flex flex-center",
                                        getType(_.get(item, 'owner')) === 'organization' ?
                                            'bg-primary-50 rounded-md' : 'background-200 rounded-full'
                                    )}
                                />
                                <div className="flex flex-col flex-1">
                                    <Link
                                        to={getLinkToDetail(item)}
                                        className="font-bold text-sm md:text-lg text-color-000 no-underline leading-snug">
                                        {getTitle(item)}
                                    </Link>
                                    <div className="space-x-1 text-xs italic">
                                            <span className="text-color-500">
                                                {t('organized by')}
                                            </span>
                                        <span className="font-medium text-xs text-blue-500 italic">
                                                {getTitle(_.get(item, 'owner'))}
                                            </span>
                                    </div>
                                </div>
                            </div>
                            <div className="flex flex-col gap-1 mt-0 md:mt-1">
                                <div className="flex flex-col md:flex-row items-start md:items-center gap-x-6 gap-y-1">
                                    <ItemInformation
                                        showIcon={true}
                                        label="type of event"
                                        value={t(_.get(item, 'event_type'))}
                                        className="text-xs italic"
                                    />
                                    <ItemInformation
                                        showIcon={true}
                                        label="start"
                                        value={formatSimplifyDate(_.get(item, 'time_open'), 'fullTime')}
                                        className="text-xs italic"
                                    />
                                </div>
                                <div className="text-color-300 tracking-wider max-lines-2">
                                    {_.get(item, 'description')}
                                </div>
                            </div>
                        </div>
                    )}
                </Translate>
            )
        case AppEntities.COURSE:
        case AppEntities.EXAMINATION:
        case AppEntities.EXAMINATION_PAPER:
        case AppEntities.ARTICLE:
            return (
                <Translate>
                    {(t) => (
                        <div className="p-3 flex flex-col gap-2 background shadow hover:shadow-md rounded-xl relative">
                            <div className="flex items-center gap-2">
                                <Avatar
                                    size={30}
                                    icon={<BsPersonFill size={14} className="text-color-500"/>}
                                    src={getAvatar(item?.creator)}
                                    className="flex flex-center background-200"
                                />
                                <div className="flex flex-col flex-1">
                                    <div className="flex items-baseline gap-1 leading-tight">
                                        <Link to={getLinkToDetail(item?.creator)}
                                              className="font-bold text-sm text-primary-900 no-underline cursor-pointer max-lines-1">
                                            {getTitle(item?.creator)}
                                        </Link>
                                        <span className="whitespace-no-wrap text-2xs text-color-500 italic">
                                                {t('posted on channel')}
                                            </span>
                                    </div>
                                    <div className="flex items-baseline gap-1 text-xs italic leading-tight">
                                        <Link to={getLinkToDetail(item?.container)}
                                              className="font-medium text-sm text-blue-500 no-underline max-lines-1 cursor-pointer">
                                            {getTitle(item?.container)}
                                        </Link>
                                        {' - '}
                                        <span className="text-2xs text-color-400 whitespace-no-wrap tracking-wide">
                                                {formatSimplifyDate(item?.created, 'fullTime')}
                                            </span>
                                    </div>
                                </div>
                            </div>
                            <div className="ml-1 flex flex-col gap-1">
                                <Link to={getLinkToDetail(item)} className="font-bold text-color-000 no-underline leading-snug">
                                    {getTitle(item)}
                                </Link>
                                <div className="w-full flex gap-2 lg:gap-3">
                                    {!_.isEmpty(item?.description) && (
                                        <div style={{lineHeight: 1.8}} className="flex-1 max-lines-3 text-base text-color-300">
                                            {item?.description}
                                        </div>
                                    )}
                                    {renderIf(
                                        item?.cover_photo,
                                        <ImageLoader
                                            fallback={Photo}
                                            src={item?.cover_photo}
                                            className="w-20 md:w-28 h-20 object-cover rounded-md"
                                            style={{objectPosition: "center"}}
                                        />
                                    )}
                                </div>
                            </div>
                            <span className="w-fit bg-primary-50 text-2xs text-primary font-medium italic capitalize"
                                  style={{ padding: '3px 10px', borderRadius: '1px 15px 15px 13px' }}>
                                {t(type)}
                            </span>
                        </div>
                    )}
                </Translate>
            )
        case AppEntities.PRODUCT:
            Component = ResultCompactItem
            break
        default:
            break
    }

    return (
        <div
            key={index}
            className="flex w-full mb-3">
            <Component {...{item}} />
        </div>
    )
}

export default createSearchResultComponent
